import { render, staticRenderFns } from "./StatsTable.vue?vue&type=template&id=fcd96ba0&lang=pug"
import script from "./StatsTable.vue?vue&type=script&lang=js"
export * from "./StatsTable.vue?vue&type=script&lang=js"
import style0 from "./StatsTable.vue?vue&type=style&index=0&id=fcd96ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports